import { AccountViewer } from "components/form/graphql/types";
import { ManagedUser } from "types/generated";

import { ManagementStrategy, UserManagementActivationStatus } from "./types";

export function getManagementStrategy(activationStatus: UserManagementActivationStatus) {
  return activationStatus === UserManagementActivationStatus.ACTIVE
    ? ManagementStrategy.USER_MANAGEMENT
    : ManagementStrategy.LOGIN_POLICY;
}

type CanRevokeUserAccessParams = {
  canManageUsers: boolean;
  viewer: Pick<AccountViewer, "id" | "identityProvider">;
  user: Pick<ManagedUser, "username" | "loginMethod">;
};

export function getCanRevokeUserAccess({
  canManageUsers,
  viewer,
  user,
}: CanRevokeUserAccessParams): boolean {
  const hasDifferentIdentityProvider =
    !!viewer.identityProvider && !!user.loginMethod && viewer.identityProvider !== user.loginMethod;

  return (viewer.id !== user.username || hasDifferentIdentityProvider) && canManageUsers;
}
